
import Header from "@/components/Header";
import Hero from "@/components/Hero";
import GamesSection from "@/components/GamesSection";
import ProgressSection from "@/components/ProgressSection";
import QuotesSection from "@/components/QuotesSection";
import Footer from "@/components/Footer";
import SEO from "@/components/SEO";
import { motion } from "framer-motion";
import { useEffect, useState } from "react";

const Index = () => {
  const [showFloatingElements, setShowFloatingElements] = useState(true);

  // Create animated floating elements for the background
  const FloatingElements = () => {
    if (!showFloatingElements) return null;
    
    const elements = [];
    const colors = ["#9b87f5", "#2DD4BF", "#8B5CF6"];
    
    for (let i = 0; i < 15; i++) {
      const size = Math.random() * 60 + 20; // 20-80px
      const x = Math.random() * 100; // 0-100%
      const y = Math.random() * 100; // 0-100%
      const delay = Math.random() * 5;
      const duration = Math.random() * 10 + 15; // 15-25s
      const color = colors[Math.floor(Math.random() * colors.length)];
      
      elements.push(
        <motion.div
          key={i}
          className="absolute rounded-full blur-2xl opacity-10 pointer-events-none"
          style={{
            width: size,
            height: size,
            left: `${x}%`,
            top: `${y}%`,
            backgroundColor: color
          }}
          animate={{
            x: [Math.random() * 100 - 50, Math.random() * 100 - 50],
            y: [Math.random() * 100 - 50, Math.random() * 100 - 50],
            opacity: [0.05, 0.2, 0.05]
          }}
          transition={{
            duration: duration,
            repeat: Infinity,
            repeatType: "reverse",
            ease: "easeInOut",
            delay: delay
          }}
        />
      );
    }
    
    return <>{elements}</>;
  };

  // Disable animations on mobile to improve performance
  useEffect(() => {
    const checkMobile = () => {
      setShowFloatingElements(window.innerWidth > 768);
    };
    
    checkMobile();
    window.addEventListener('resize', checkMobile);
    
    return () => window.removeEventListener('resize', checkMobile);
  }, []);

  return (
    <div className="min-h-screen flex flex-col bg-gradient-to-br from-white to-brain-soft-purple/10 relative overflow-hidden">
      <SEO 
        title="Brain Wave Arcade | Train Your Brain with Fun Games | GamePlay"
        description="Welcome to Brain Wave Arcade - the ultimate platform for cognitive training through engaging games. Improve memory, focus, problem-solving, and more."
        ogType="website"
      />
      
      {/* Animated background elements */}
      <div className="fixed inset-0 overflow-hidden -z-10">
        <FloatingElements />
      </div>
      
      <Header />
      <main className="flex-grow">
        <Hero />
        <motion.div 
          className="relative z-10"
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          transition={{ duration: 0.5, delay: 0.3 }}
        >
          <GamesSection />
        </motion.div>
        {/* <motion.div 
          className="relative z-10"
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          transition={{ duration: 0.5, delay: 0.4 }}
        >
          <ProgressSection />
        </motion.div> */}
        <motion.div 
          className="relative z-10"
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          transition={{ duration: 0.5, delay: 0.5 }}
        >
          <QuotesSection />
        </motion.div>
      </main>
      <Footer />
    </div>
  );
};

export default Index;
